import ApeironOperateButton, {
  ApeironOperateButtonProps
} from '@src/components/share/apeiron/ApeironOperateButton'
import { OperateButton } from '@src/constants/variant'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const MorphButton: FC<ApeironOperateButtonProps> = (
  props: ApeironOperateButtonProps
) => {
  const { t } = useTranslation()

  return (
    <ApeironOperateButton
      {...props}
      label={t('common.button.morph_to_adult')}
      variant={OperateButton.Long}
    />
  )
}

export default MorphButton
